import { Map as ImmutableMap, fromJS } from 'immutable';
import { FetchNotificationsActionTypes, UpdateWeeklyProgressReportSubscriptionActionTypes, UpdateMonthlyMarketingReportSubscriptionActionTypes, UpdateCalendarNotificationActionTypes, UpdateSuccessNotificationActionTypes, UpdateProjectsNotificationActionTypes, UpdateLeadRevisitNotificationActionTypes } from '../actions/NotificationActions';
import NotificationTypes from '../constants/NotificationTypes';
import { handleActions } from 'flux-actions';
const initialState = ImmutableMap();
export default handleActions({
  [FetchNotificationsActionTypes.SUCCESS](state, action) {
    return state.withMutations(map => {
      action.payload.data.forEach(notification => {
        map.set(notification.type, fromJS(notification));
      });
    });
  },
  [UpdateWeeklyProgressReportSubscriptionActionTypes.SUCCESS](state, action) {
    return state.setIn([action.payload.props.notificationType, 'subscribed'], action.payload.props.subscribed);
  },
  [UpdateMonthlyMarketingReportSubscriptionActionTypes.SUCCESS](state, action) {
    return state.setIn([action.payload.props.notificationType, 'subscribed'], action.payload.props.subscribed);
  },
  [UpdateCalendarNotificationActionTypes.SUCCESS](state, action) {
    return state.setIn([action.payload.props.notificationType, 'subscribed'], action.payload.props.subscribed);
  },
  [UpdateSuccessNotificationActionTypes.SUCCESS](state, action) {
    return state.setIn([action.payload.props.notificationType, 'subscribed'], action.payload.props.subscribed);
  },
  [UpdateProjectsNotificationActionTypes.SUCCESS](state, action) {
    return state.setIn([action.payload.props.notificationType, 'subscribed'], action.payload.props.subscribed);
  },
  [UpdateLeadRevisitNotificationActionTypes.SUCCESS](state, action) {
    return state.setIn([NotificationTypes.LEAD_REVISIT, 'value'], action.payload.props.leadRevisitType);
  }
}, initialState);